'use strict';
require('../../modules/es.array.iterator');
require('../../modules/es.object.from-entries');
var path = require('../../internals/path');

module.exports = path.Object.fromEntries;



//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-auth-js/~/core-js/es/object/from-entries.js
// module id = 340
// module chunks = 0